<template>
  <div class='billCopy'>
    <div class="YTitle">收到抄送工单</div>

    <div class="from">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="申请人：">
          <el-input v-model.trim="formInline.applicat" placeholder="请输入申请人"></el-input>
        </el-form-item>
        <el-form-item label="开始时间：">
          <el-date-picker
            v-model.trim="formInline.startTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format='yyyy-MM-dd HH:mm:ss'>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成时间：">
          <el-date-picker
            v-model.trim="formInline.endTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format='yyyy-MM-dd HH:mm:ss'>
          </el-date-picker>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="onSubmit" round>查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table
        :data="TableData"
        border
        height='100%'
        style="width: 100%">
        <el-table-column
          v-for="(item, index) in TableHead"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          align='center'>
        </el-table-column>
        <el-table-column
          align='center'
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="EditClick(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <YPagination
      :pageNum='pageNum'
      :pageSize='pageSize'
      :Total='Total'
      @SizeChange='SizeChange'
      @CurrentChange='CurrentChange'>
    </YPagination>

    <Particulars v-if="ParticularsShow" :data='ParticularsData' @close='close'></Particulars>
  </div>
</template>

<script>
import api from '@/shared/api/apps/requisition'
import Particulars from '../components/particulars'
export default {
  name: 'billCopy',

  components: { Particulars },

  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      Total: 0,
      ParticularsShow: false,
      ParticularsData: {},
      formInline: {
        applicat: '',
        startTime: [],
        endTime: []
      },
      TableHead: [
        {
          prop: 'jobId',
          label: '工单ID'
        },
        {
          prop: 'applicat',
          label: '申请人'
        },
        {
          prop: 'title',
          label: '审批类型'
        },
        {
          prop: 'createTime',
          label: '发起时间'
        },
        {
          prop: 'finishTime',
          label: '完成时间'
        },
        {
          prop: 'jobStatus.name',
          label: '审批状态'
        }
      ],
      TableData: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getData()
    },

    getData () {
      const params = {
        method: api.pageList,
        applicat: this.formInline.applicat,
        startCreateTime: this.formInline.startTime.length > 0 ? this.formInline.startTime[0] : '',
        startFinishTime: this.formInline.startTime.length > 0 ? this.formInline.startTime[1] : '',
        endCreateTime: this.formInline.endTime.length > 0 ? this.formInline.endTime[0] : '',
        endFinishTime: this.formInline.endTime.length > 0 ? this.formInline.endTime[1] : '',
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        queryType: 3
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_odc_flow_flowJob_page_list_response.code !== '10000') return
        this.TableData = res.data.backend_odc_flow_flowJob_page_list_response.result.records
        this.Total = parseInt(res.data.backend_odc_flow_flowJob_page_list_response.result.total)
      })
    },

    onSubmit () {
      this.getData()
    },

    EditClick (val) {
      this.ParticularsData = val
      this.ParticularsShow = true
    },

    SizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },

    CurrentChange (val) {
      this.pageNum = val
      this.getData()
    },

    close () {
      this.ParticularsShow = false
    }
  }
}
</script>

<style lang='stylus' scoped>
  .billCopy
    width 100%
    height 100%
    display flex
    flex-direction column
    position relative
    .table
      flex auto
      overflow auto
      margin-bottom 20px
</style>
